@if (isMenu) {
  <button mat-menu-item>
    <mat-icon>folder_open</mat-icon>
    {{ 'moveToDraft' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'moveToDraft' | translate"
    matTooltip="{{ 'moveToDraft' | translate }}">
    <mat-icon>folder_open</mat-icon>
  </button>
}
